import { render, staticRenderFns } from "./order_attribute.vue?vue&type=template&id=487fb9a6&scoped=true&"
import script from "./order_attribute.vue?vue&type=script&lang=js&"
export * from "./order_attribute.vue?vue&type=script&lang=js&"
import style0 from "./order_attribute.vue?vue&type=style&index=0&id=487fb9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487fb9a6",
  null
  
)

export default component.exports